import React, {useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";
import helpers from "../../Utils/helpers";
import { OrderSummary } from "../../Components/OrderPlacement/OrderComponents/OrderSummary";
import { bindActionCreators } from "redux";
import orderActions from "../../Actions/orderActions";
import commonActions from "../../Actions/commonActions";
import customerActions from "../../Actions/customerActions";
import subscriptionActions from "../../Actions/Voss/subscriptionActions";
import Card from "../../Components/Card/Card";
import {Button, ButtonDirection, ButtonOption} from "../../Components/Fundamentals/Button";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import customerRoutes from "../../Constants/Customer/customerRoutes";
import useModal from "../../Hooks/useModal";
import modals from "../../Constants/modals";
import ConfirmOrderModal from "../../Components/Modals/Order/ConfirmOrderModal";

export const OrderCartContainer = ({ order, customer, orderActions, disabled, product, quotationCustomerForm, orderForm, commonActions, sourceSystem, customerActions }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { openModal, isModalOpen } = useModal();

    useEffect(() => {
        helpers.scrollToBottom()
    }, [order?.orderlines?.length]);

    const onCancel = () => {
        orderActions.cancel(
            order.orderId,
            order.customerNumber,
            () => navigate(customerRoutes.customer(customer.pathId))
        );
    };
    
    if (!order) return null;
    
    const isQuotation =
        order.status === 4 || order.quotationInProgress;

    const isAboveCreditLimit =
        order && customer.vbCustomer && order.totalInitialPrice > customer.vbCustomer.creditLimit && !order.hasCreditLimitExemption;
    
    return <Card>
        <Card.Header>
            <Card.Header.Title>{t('ordercartcontainer.cart')}</Card.Header.Title>
        </Card.Header>
        <Card.Content>
            <OrderSummary orderActions={orderActions} order={order} product={product} customer={customer} />
        </Card.Content>
        <Card.Footer>
            <Card.Footer.Buttons>
                <Button onClick={() => onCancel()}>{t('ordercartcontainer.cancel')}</Button>
                <Button option={ButtonOption.PRIMARY} direction={ButtonDirection.RIGHT} disabled={disabled} onClick={() => openModal(modals.ConfirmOrderModal)}>{disabled ? t('ordercartcontainer.complete') : isQuotation ? t('ordercartcontainer.sendquotation') : isAboveCreditLimit ? t('ordercartcontainer.requestapproval') : t('ordercartcontainer.completeorder')}</Button>
            </Card.Footer.Buttons>
        </Card.Footer>
        {isModalOpen(modals.ConfirmOrderModal) && <ConfirmOrderModal
            isQuotation={isQuotation}
            isAboveCreditLimit={isAboveCreditLimit}
            customer={customer}
            orderActions={orderActions}
            commonActions={commonActions}
            order={order}
            quotationCustomerForm={quotationCustomerForm}
            orderForm={orderForm}
            sourceSystem={sourceSystem}
            customerActions={customerActions}
        />}
    </Card>
}

const mapDispatchToProps = (dispatch) => ({
    orderActions: bindActionCreators(orderActions, dispatch),
    customerActions: bindActionCreators(customerActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    subscriptionActions: bindActionCreators(subscriptionActions, dispatch)
});

const mapStateToProps = (state) => ({
    order: state.OrderReducer.order,
    customer: state.CustomerReducer.customer,
    orderForm: state.CommonReducer.forms && state.CommonReducer.forms.orderForm,
    pushedQuotation: state.OrderReducer.pushedQuotation,
    product: state.OrderReducer.product,
    quotationCustomerForm: state.CommonReducer.forms && state.CommonReducer.forms.quotationCustomerForm,
    sourceSystem: state.OrderReducer.sourceSystem && state.OrderReducer.sourceSystem
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderCartContainer);

